import { useState } from 'react';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PhotoIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

/**
 * Tira de miniaturas de la documentación subida, pegada arriba del formulario.
 *
 * Se queda fija al hacer scroll para que el agente pueda contrastar lo que
 * tiene escrito con el escaneo sin perder el sitio. Al pulsar una miniatura se
 * abre el visor a pantalla completa.
 */
const PanelDocumentos = ({ imagenes, onAbrir }) => {
    const { t } = useTranslation();
    const [abierto, setAbierto] = useState(true);

    if (imagenes.length === 0) return null;

    return (
        <div className="sticky top-0 z-20 -mx-4 sm:mx-0 mb-6 rounded-none sm:rounded-lg border-y sm:border border-gray-200 dark:border-gray-700 bg-white/95 dark:bg-gray-800/95 backdrop-blur shadow-sm">
            <button
                type="button"
                onClick={() => setAbierto((v) => !v)}
                className="w-full flex items-center justify-between gap-3 px-4 py-3 text-sm font-medium text-gray-700 dark:text-gray-300"
            >
                <span className="flex items-center gap-2">
                    <PhotoIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" />
                    {t('Documentación subida')}
                    <span className="text-gray-400 dark:text-gray-500">({imagenes.length})</span>
                </span>
                <ChevronDownIcon className={'w-5 h-5 text-gray-400 transition-transform ' + (abierto ? 'rotate-180' : '')} />
            </button>

            {abierto && (
                <div className="px-4 pb-4">
                    <div className="flex gap-3 overflow-x-auto pb-1">
                        {imagenes.map((imagen, i) => (
                            <button
                                key={imagen.nombre + i}
                                type="button"
                                onClick={() => onAbrir(i)}
                                title={imagen.nombre}
                                className="group flex-shrink-0 w-24 text-left"
                            >
                                <div className="w-24 h-24 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-600 group-hover:border-primary-500 transition-colors">
                                    <img src={imagen.url} alt={imagen.nombre} className="w-full h-full object-cover" />
                                </div>
                                <span className="block mt-1 text-xs text-gray-500 dark:text-gray-400 truncate">
                                    {imagen.etiqueta || imagen.nombre}
                                </span>
                            </button>
                        ))}
                    </div>
                    <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                        {t('Pulsa una imagen para ampliarla y comprobar los datos sin salir del formulario')}
                    </p>
                </div>
            )}
        </div>
    );
};

PanelDocumentos.propTypes = {
    imagenes: propTypes.array.isRequired,
    onAbrir: propTypes.func.isRequired,
};

export default PanelDocumentos;
